import { QueryClient } from '@tanstack/react-query';
import Pubnub from 'pubnub';

import { handlePresenceEvent } from './handlePresenceEvent';

export const presenceEventHandlerFactory =
  ({
    queryClient,
    channels,
    activityInstanceId,
    isRosteredRoom,
    ownUuid,
  }: {
    queryClient: QueryClient;
    activityInstanceId: number;
    isRosteredRoom: boolean;
    channels: string[];
    ownUuid: string;
  }) =>
  (event: Pubnub.PresenceEvent) => {
    if (!channels.includes(event.channel)) {
      return;
    }

    // Whenever `pubnub.subscribe` is called, a join even happens.
    // It doesn't make sense to pay attention to whenever you join a room.
    if (event.uuid === ownUuid) {
      return;
    }

    handlePresenceEvent({
      queryClient,
      activityInstanceId,
      isRosteredRoom,
      event,
    });

    return event;
  };
